<template>
	<v-card>
		<v-card-title>
			<v-layout justify-space-between align-baseline>
				<v-flex shrink>
					<h1 class="heading">{{ item.title }}</h1>
				</v-flex>
				<v-flex shrink>
					<v-layout align-center>
						<v-btn icon class="mr-1" :disabled="isLikeCreatePending || isLikeRemovePending"  @click="toggleLike">
							<v-icon color="red">{{ hasUserLiked ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
						</v-btn>
						<span class="mr-3">{{ item.nbLikes }}</span>
						<v-chip label disabled class="ma-0">{{ item.category }}</v-chip>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-card-title>
		<!-- <v-divider></v-divider> -->

		<v-subheader class="subheading">{{ $t('ACTION_HEADER_CLAIM') }}</v-subheader>
		<v-card-text class="pt-0 compiled-md-text" v-html="compile(item.claim)" />

		<v-subheader class="subheading">{{ $t('ACTION_HEADER_DESCRIPTION') }}</v-subheader>
		<v-card-text class="pt-0 compiled-md-text" v-html="compile(item.description)" />

		<v-subheader class="subheading">{{ $t('ACTION_HEADER_DURATION') }}</v-subheader>
		<v-card-text class="pt-0 compiled-md-text" v-html="compile(item.duration)" />

		<v-subheader class="subheading">{{ $t('ACTION_HEADER_REQUIRED_PEOPLE') }}</v-subheader>
		<v-card-text class="pt-0 compiled-md-text" v-html="compile(item.requiredPeople)" />

		<v-subheader class="subheading">{{ $t('ACTION_HEADER_REQUIRED_STUFF') }}</v-subheader>
		<v-card-text class="pt-0 compiled-md-text" v-html="compile(item.requiredStuff)" />

		<v-subheader class="subheading">{{ $t('ACTION_HEADER_TONE') }}</v-subheader>
		<v-card-text class="pt-0 compiled-md-text">
			<v-layout class="mb-2">
				<span class="mr-3 font-italic">{{ $ta('GENERAL_TONE_LEVELS', item.tone || 0) }}</span>
				<v-rating
					dense
					readonly
					small
					:value="item.tone"
					empty-icon="mdi-human-greeting"
					full-icon="mdi-human-greeting"
					background-color="grey ligthen-2"
					color="orange darken-1" />
			</v-layout>
			<div v-html="compile(item.toneComment)" />
		</v-card-text>

		<v-subheader class="subheading">{{ $t('ACTION_HEADER_RISK') }}</v-subheader>
		<v-card-text class="pt-0 compiled-md-text">
			<v-layout class="mb-2">
				<span class="mr-3 font-italic">{{ $ta('GENERAL_RISK_LEVELS', item.risk || 0) }}</span>
				<v-rating
					dense
					readonly
					small
					:value="item.risk"
					empty-icon="mdi-alert-outline"
					full-icon="mdi-alert"
					background-color="red darken-3"
					color="red darken-3" />
			</v-layout>
			<div v-html="compile(item.riskComment)" />
		</v-card-text>

		<feedback-list
			:actionID="item && item.id"
			:feedbacks="feedbacks"
			:maxVisibleFeedbacks="maxVisibleFeedbacks"
			:maxInlineFeedbacks="maxInlineFeedbacks"
			@showAll="navToFeedbackList"
			@show="navToFeedback" />

		<comment-list
			:actionID="item && item.id"
			:comments="comments"
			:maxVisibleComments="maxVisibleComments"
			:maxInlineComments="maxInlineComments"
			@showAll="navToCommentList"/>
		
	</v-card>
</template>


<script>
import { mapState, mapGetters } from 'vuex';
import CommentList from '@/components/CommentList';
import FeedbackList from '@/components/FeedbackList';
import { toRelativeDate } from '@/utils/formatters';
import { compile } from '@/utils/markdown';

export default {
	name: 'action-card',
	components: { CommentList, FeedbackList  },
	props: {
		'item':      { type: Object, default: () => ({}) },
		'comments':  { type: Array,  default: () => ([]) },
		'feedbacks': { type: Array,  default: () => ([]) },
	},
	data: () => ({
		maxInlineComments: 10,
		maxVisibleComments: 5,
		maxInlineFeedbacks: 20,
		maxVisibleFeedbacks: 10,
	}),
	computed: {
		...mapGetters('auth', ['userID']),
		
		...mapState('likes', {
			isLikeCreatePending: 'isCreatePending',
			isLikeRemovePending: 'isRemovePending',
		}),
		hasUserLiked() {
			return this.$store.getters['likes/hasUserLikedAction'](this.item.id, this.userID);
		},
	},
	filters: {
		toRelativeDate,
	},
	methods: {
		compile,
		// compile: x => x,
		navToCommentList() {
			this.$router.push({ name: 'action-comment-list', params: { id: this.item.id } });
		},
		navToFeedbackList() {
			this.$router.push({ name: 'action-feedback-list', params: { id: this.item.id } });
		},
		navToFeedback(fdbk) {
			this.$router.push({ name: 'action-feedback', params: { id: this.item.id, fdbk: fdbk.id } });
		},

		async toggleLike() {
			const actionName = this.hasUserLiked ? 'unlikeAction' : 'likeAction';
			this.likePending = true;
			await this.$store.dispatch(`likes/${actionName}`, this.item.id);
			this.likePending = false;
		},
	}
}
</script>
